import React from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

 const Swagger = ({appId, accountName, entityId}) => {
  return (entityId ?
    <SwaggerUI url={`https://sinexiar.com/${accountName}-${appId}/swagger/entities/${entityId}`} />
    :
    <SwaggerUI url={`https://sinexiar.com/${accountName}-${appId}/swagger/catalog-endpoints`} />
  )
 }

export default Swagger;
